import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CalendarClock, Send } from "lucide-react";
import { toast } from "sonner";

export const WeeklyReportCard = () => {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/backup/settings").then((r) => setCfg(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const sendNow = async () => {
    setBusy(true);
    try { await api.post("/report/weekly/send-now"); toast.success("Haftalık rapor gönderildi"); }
    catch (e) { toast.error(e.response?.data?.detail || "Gönderilemedi"); }
    finally { setBusy(false); load(); }
  };

  return (
    <section className="mt-5 rounded-lg border border-[#DCCFB8] bg-[#FFFBF4] p-6" data-testid="weekly-report-card">
      <div className="flex items-center gap-2 mb-1">
        <CalendarClock className="w-5 h-5 text-[#B45309]" />
        <h2 className="font-display text-xl font-bold uppercase tracking-tight">Haftalık Rapor</h2>
      </div>
      <p className="text-sm text-[#6B5B4A] mb-4">
        Her pazartesi 10:00&apos;da geçen haftanın kesim, sevkiyat, yeni sipariş toplamları, model/renk ve müşteri dökümü ile bekleyen siparişler yukarıdaki e-posta adresine gönderilir.
      </p>
      <Button variant="outline" onClick={sendNow} disabled={busy || !cfg?.email} data-testid="weekly-report-send-now"
        className="h-11 border-[#DCCFB8] bg-transparent text-[#B45309]">
        <Send className="w-4 h-4 mr-1" /> {busy ? "Gönderiliyor..." : "Geçen Haftanın Raporunu Şimdi Gönder"}
      </Button>
      {cfg && !cfg.email && <p className="text-xs mt-3 text-[#B45309]" data-testid="weekly-report-no-email">Önce yedek e-posta adresini kaydedin.</p>}
      {cfg?.last_report_at && (
        <p className={`text-xs mt-3 ${cfg.last_report_error ? "text-[#B91C1C]" : "text-[#047857]"}`} data-testid="weekly-report-status">
          Son rapor: {new Date(cfg.last_report_at).toLocaleString("tr-TR")} — {cfg.last_report_error || "başarılı"}
        </p>
      )}
    </section>
  );
};
